<template>
  <div id="Overviewitemcomponents">
    <el-row class="block-col-2">
      <el-col>
        <el-dropdown trigger="click"  @command="handleCommand">
          <span class="el-dropdown-link">
            {{nameSeat==""?loopName:nameSeat}}<i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item
              v-for="(item, index) in seat"
              :key="index"
              :command="index">
              <p class="loopname" :title="item.loopName">{{ item.loopName }}</p></el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import { chainIndex } from "../../../api/linkindex";
export default {
  name: "Overviewitemcomponents",
  data() {
    return {
      loopName:"",
      felice: "",
      seat: [],
      id: 0,
      nameSeat:"",
      jinxian:[]
    };
  },
  mounted() {
    this.felt();
  },
watch:{
     jinxian(n, o) {
          this.jinxian=n
    },
    '$store.state.homeitem.areaId'(n,o){
      this.felt();
    }
},
  methods: {
    felt() {
      
   this.id=this.$store.state.project.currentProject.projectId
      chainIndex.totalAll(this.id).then((res) => {
      this.seat=res.data.data.deviceLoops.filter(array=>{
         if (array.loopType=="IN"&&this.$store.state.homeitem.areaId==array.aid) {
          this.jinxian.push(array)
          return array;
        } 
      })
      
      if(this.seat.length){
        this.nameSeat=this.seat[0].loopName
         this.loopName=this.seat[0].loopName 
        this.$emit("compitem",this.seat[0].subLoopUrl) 
      }else{
        this.loopName=""
      }
      });
    },
        handleCommand(command) {
         this.seat.forEach((item, index) => {
        if (index == command) {
          this.nameSeat=item.loopName
        //   console.log(item,"我是")
               this.$emit("compitem",item.subLoopUrl) 
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
.loopname{
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
#Overviewitemcomponents{
  line-height: 18px;
  font-size: 18px !important;
  .el-dropdown{
    font-size: 20rem !important;
  }
}
.el-icon-arrow-down {
  font-size: 12rem;
}
.el-popper{
  overflow-x:visible
}
.el-dropdown-menu {
  width: 10% !important;
  max-height: 20% !important;
  position: fixed;
right: 20rem  !important;
// top:45% !important;
overflow-y:scroll;
overflow-x:hidden;
white-space: nowrap;
 scrollbar-width: none;
  -ms-overflow-style: none;
}
.el-dropdown-menu::-webkit-scrollbar{
	display:none
}
.el-dropdown-menu__item{
  // width: 200rem !important;
  text-align: center;
}
.demonstration {
  display: block;
  color: #8492a6;
  font-size: 14rem;
  margin-bottom: 20rem;
}
#inp {
  .w(280);
  .h(32);
  background: #ffffff;
  border: 1rem solid #000000;
  opacity: 0.15;
  border-radius: 16rem;
  margin-bottom: 6rem;
  margin-left: 16rem;
  margin-top: 16rem;
  padding: 5rem 18rem 4rem 15rem;
  display: flex;
  justify-content: space-between;
  #sousuo {
    .w(18);
    .h(18);
    background-color: black;
  }
  #div-inp {
    .w(300);
    font-size: 16rem;
    border: none;
    outline: none;
  }
}
.el-dropdown-link{
   cursor:pointer;
   
}
::v-deep .el-dropdown-link:focus {
  outline: none;
} 
</style>